module.exports = __webpack_public_path__ + "static/img/360js_img_4.f9fe0ab3.png";